module.exports = __webpack_public_path__ + "static/media/ic_更改分类.a7a7e3b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_更改分类.svg
// module id = 367
// module chunks = 0